export enum Quality {
    LOW,
    HIGH,
}

export default class QualityManager {
    private _quality: Quality;
    private _resolution: number;

    public get quality(): Quality {
        return this._quality;
    }

    public get resolution(): number {
        return this._resolution;
    }

    // resolution should be 0.5 if we're shrinking the images to half-resolution.
    // if we're just compressing them, resolution is 1 and quality is LOW
    constructor(resolution: number, quality: Quality) {
        this._resolution = resolution;
        this._quality = quality;
    }

    public get qualitySuffix(): string {
        if (this.quality == Quality.HIGH) return "";
        if (this.quality == Quality.LOW) return "@0.5";
        return "";
    }

    public get resolutionSuffix(): string {
        if (this.resolution == 1) return "";
        if (this.resolution == 0.5) return "@0.5";
        return "";
    }
    
}
